/** Redirect path for doctor-only dashboard access. Used by PatientRouteLayout and Router. */
export const doctorDashboardRedirectPath = "/app/clinic/dashboard";
export const defaultRedirectPath = "/app/clinic/dashboard/todo/active";
export const onpremDebugRedirectPath = "/app/clinic/dashboard/onpremsetup/test";
export const userManagementRedirectPath = "/app/clinic/dashboard/users";
